import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import formatDateString from 'tio-common/helpers/format-date-string';

interface LoanMetaSignature {
  Args: {
    /** A held loan's type as its document states it, else its label; an existing loan's label. */
    label: string;
    /** `YYYY-MM-DD`, rendered as a calendar date with no timezone shift. */
    disbursedOn: string | null;
  };
}

/** A loan's "{label} · Disbursed {date}" line, dropping whichever half the server did not send. */
const LoanMeta: TOC<LoanMetaSignature> = <template>
  {{#if (and @label @disbursedOn)}}
    {{t "slr.loan_verification.meta" label=@label date=(formatDateString @disbursedOn)}}
  {{else if @disbursedOn}}
    {{t "slr.loan_verification.disbursed" date=(formatDateString @disbursedOn)}}
  {{else}}
    {{@label}}
  {{/if}}
</template>;

export default LoanMeta;
